<mat-card class="card">
  <div class="flex items-center justify-between">
    <mat-card-title>Workflows</mat-card-title>
    @if (!isMobile) {
      <button
        class="btn-green btn-medium"
        (click)="openCreateWorkflowDialog()"
        [showForClientAdmin]="true"
        avsRestrictedEl
      >
        <mat-icon>add</mat-icon>
        Add workflow
      </button>
    }
  </div>
  @if (workflowStore.isLoading()) {
    <ngx-skeleton-loader [theme]="{ height: '50px' }" />
  } @else {
    <ul>
      @for (workflow of workflowStore.workflowRenderList(); track workflow.id) {
        <li class="border border-ui-gray-light rounded-md text-sm p-3 mt-4">
          <div class="flex items-center mb-4">
            <span class="text-ui-dark font-semibold mr-1 whitespace-nowrap overflow-hidden text-ellipsis">
              {{ workflow.name || workflow.id }}
            </span>
            <avs-workflow-status
              class="mx-4 shrink-0"
              [status]="workflow.status"
            />

            <div
              class="flex items-center ml-auto"
              [showForClientAdmin]="true"
              avsRestrictedEl
            >
              @if (!isMobile) {
                <i
                  class="icon-edit action-icon mr-2"
                  (click)="editWorkflow(workflow)"
                  matTooltip="Edit"
                ></i>
              }
              @if ([eWorkflowStatus.ACTIVE, eWorkflowStatus.DISABLED, eWorkflowStatus.ATTEMPTS_EXCEEDED, eWorkflowStatus.TWO_WAY_COMMUNICATION_DISABLED].includes(workflow.status)) {
                <button
                  class="icon-btn mr-2"
                  (click)="changeWorkflowStatus(workflow, eWorkflowStatus.PAUSED)"
                  [disabled]="[eWorkflowStatus.DISABLED, eWorkflowStatus.ATTEMPTS_EXCEEDED, eWorkflowStatus.TWO_WAY_COMMUNICATION_DISABLED].includes(workflow.status)"
                  matTooltip="Pause"
                >
                  <i class="icon-pause-16 action-icon text-3xl"></i>
                </button>
              }
              @if (workflow.status === eWorkflowStatus.ATTEMPT_RUNNING) {
                <button
                  class="icon-btn"
                  (click)="changeWorkflowStatus(workflow, eWorkflowStatus.ATTEMPTS_EXCEEDED)"
                  matTooltip="Attempt Exceeded"
                >
                  <mat-icon class="action-icon">stop</mat-icon>
                </button>
              }
              @if (workflow.status === eWorkflowStatus.PAUSED) {
                <button
                  class="icon-btn"
                  (click)="changeWorkflowStatus(workflow, eWorkflowStatus.ACTIVE)"
                  matTooltip="Activate"
                >
                  <i class="icon-play-16 action-icon text-3xl"></i>
                </button>
              }
            </div>
          </div>

          <div
            class="mb-3"
            [class.flex.items-center]="!isMobile"
          >
            @let disabledByAdmin = eWorkflowStatus.DISABLED === workflow.status;
            @let workflowUnit = workflow.unit;

            <span class="font-semibold text-ui-gray-750 mr-4">IF</span>
            <span class="text-ui-dark">{{ workflow.code }}</span>
            @if (isMobile) {
              <br>
            }
            @if (workflowUnit) {
              <span
                class="text-ui-gray-100 ml-3"
                [matTooltip]="workflowUnit.display"
              > ({{ workflowUnit.displayShort }})</span>
            }
            <span class="font-semibold text-ui-gray-750 mx-4">{{ workflow.operator }}</span>
            <span class="text-ui-dark mr-4">{{ workflow.conditionValue }}</span>
            <span class="font-semibold text-ui-gray-750 mr-4">THEN</span>
            <span
              [matTooltipDisabled]="!disabledByAdmin"
              [ngClass]="!disabledByAdmin ? 'text-ui-dark' : 'text-ui-red-50'"
              matTooltip="Action Point was disabled by Super Admin. Edit the workflow and select another Action point."
            >{{ workflow.actionPointName }}</span>
          </div>
          <div class="flex">
            @if (!(workflow.status === eWorkflowStatus.PAUSED || disabledByAdmin)) {
              <div class="flex items-center mr-5">
                <span class="font-semibold mr-3">Attempt</span>
                <span>{{ workflow.currentAttempts }}/{{ workflow.maxAttempts }}</span>
              </div>
              @if (workflow.status === eWorkflowStatus.ATTEMPT_RUNNING) {
                <avs-workflow-attempt-timeout
                  class="flex-1"
                  [lastExecutedAt]="workflow.lastExecutedAt"
                  [timeout]="workflow.timeoutBetweenAttempts"
                />
              }
            }
            @if ('workflow-schedule' | avsFeatureFlag) {
              <avs-schedule-info
                [scheduleConfig]="workflow.scheduleConfig"
                [scheduleEnabled]="!!workflow.scheduleEnabled"
              />
            }
          </div>
        </li>
      } @empty {
        <avs-no-data-placeholder noDataText="No workflows created yet" />
      }
    </ul>
  }
</mat-card>
